module.exports = __webpack_public_path__ + "static/img/pro-icon-4.18e6acf.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/new-img/pro-icon-4.jpg
// module id = JMVH
// module chunks = 13